import { USER_ROLES, resolveUserRoleName } from "../constants";

/** True when the signed-in user is a Surveyor (SRVY). */
export const isSurveyorUser = (user) => {
  if (!user) return false;
  const roleName = resolveUserRoleName(user);
  return roleName === USER_ROLES.SRVY || user.roleId === 12;
};

/** HR Documents write actions (upload, edit, save). Surveyors are always excluded. */
export const canMutateHrDocuments = ({ isEmployeeInactive, isSurveyRole }) =>
  !isEmployeeInactive && !isSurveyRole;

/** HR Documents read access (list, view, print). */
export const canViewHrDocuments = ({ isEmployeeInactive }) => !isEmployeeInactive;

/**
 * Whether an application/medical/evaluation row can be opened from HR Documents.
 * Surveyor lists only include submitted rows; those stay read-only.
 */
export const canOpenDocumentFormRow = ({ isSurveyRole, hasDetail }) =>
  isSurveyRole || hasDetail;

/** Label for the primary row action in HR Documents tables. */
export const getDocumentFormActionLabel = ({ isSurveyRole, canMutate, hasDetail }) => {
  if (isSurveyRole) return "View";
  if (canMutate && hasDetail) return "Edit";
  return "Edit";
};

/**
 * Build URL to open an application library form from HR Documents.
 * Omits actualFromId when there is no saved record (pending / not started).
 */
export const buildApplicationFormDocumentUrl = ({
  positionId,
  userId,
  formId,
  recordId,
  tab,
  returnUrl,
}) => {
  const params = new URLSearchParams();
  params.set("userId", String(userId));
  params.set("formId", String(formId));
  if (tab) params.set("tab", tab);
  if (returnUrl) params.set("returnUrl", returnUrl);
  if (recordId != null && recordId !== "") {
    params.set("actualFromId", String(recordId));
  }
  return `/applications/${positionId}?${params.toString()}`;
};

/** Build URL to open an evaluation from HR Documents (read-only for surveyors via formPermissions). */
export const buildEvaluationDocumentUrl = ({
  role,
  evalId,
  userId,
  tab,
  returnUrl,
}) => {
  const params = new URLSearchParams();
  params.set("userId", String(userId));
  if (tab) params.set("tab", tab);
  if (returnUrl) params.set("returnUrl", returnUrl);
  const query = params.toString();
  const roleSlug = String(role || "rn").toLowerCase();
  if (evalId != null && evalId !== "") {
    return `/evaluation/${roleSlug}/edit/${evalId}?${query}`;
  }
  // Pending / not started — open blank form (surveyor read-only via formPermissions)
  return `/evaluation/${roleSlug}/edit?${query}`;
};
